import { XyCoordinates } from "../../xy-coordinates.interface";
import { GridLineContext } from "./grid-line-context.interface";
import { GridLine, GridLineType } from "./grid-line.interface";

type GetRectCoordinates = (index: number) => XyCoordinates;

export const getColumnCoordinates = (canvasWidth: number, numberOfColumns: number) => (
  i: number
) => ({
  x: (canvasWidth / numberOfColumns) * (i + 1),
  y: 1,
});

export const getRowCoordinates = (canvasHeight: number, numberOfRows: number) => (i: number) => ({
  x: 1,
  y: (canvasHeight / numberOfRows) * (i + 1),
});

export const getRowDragBoundaries = (context: GridLineContext) => (
  pos: XyCoordinates
): XyCoordinates => {
  const getMinY = () => {
    if (context.lineIndex === 0) {
      return 10;
    }
    return context.lines[context.lineIndex - 1].y + 10;
  };

  const getMaxY = () => {
    if (context.lineIndex === context.lines.length - 1) {
      return context.canvasHeight - 10;
    }
    return context.lines[context.lineIndex + 1].y - 10;
  };

  const getY = () => {
    const minY = getMinY();
    const maxY = getMaxY();

    if (pos.y < minY) {
      return minY;
    }
    if (pos.y > maxY) {
      return maxY;
    }
    return pos.y;
  };

  return {
    x: 1,
    y: getY(),
  };
};

export const getColDragBoundaries = (context: GridLineContext) => (
  pos: XyCoordinates
): XyCoordinates => {
  const getMinX = () => {
    if (context.lineIndex === 0) {
      return 10;
    }
    return context.lines[context.lineIndex - 1].x + 10;
  };

  const getMax = () => {
    if (context.lineIndex === context.lines.length - 1) {
      return context.canvasWidth - 10;
    }
    return context.lines[context.lineIndex + 1].x - 10;
  };

  const getX = () => {
    const minX = getMinX();
    const maxX = getMax();

    if (pos.x < minX) {
      return minX;
    }
    if (pos.x > maxX) {
      return maxX;
    }
    return pos.x;
  };

  return {
    x: getX(),
    y: 1,
  };
};

export function scaleGridLines(
  lines: GridLine[],
  newCanvas: XyCoordinates,
  prevCanvas: XyCoordinates
) {
  const xScale = () => newCanvas.x / prevCanvas.x;
  const yScale = () => newCanvas.y / prevCanvas.y;
  return lines.map((line) => ({
    ...line,
    x: line.x * xScale(),
    y: line.y * yScale(),
    width: line.width * xScale(),
    height: line.height * yScale(),
  }));
}

export function createGridLines(
  amount: number,
  canvas: XyCoordinates,
  type: GridLineType,
  getCoordinates: GetRectCoordinates
): GridLine[] {
  let lines: GridLine[] = [];

  for (let i = 0; i < amount - 1; i++) {
    const coords = getCoordinates(i);

    const width = type === "col" ? 2 : canvas.x;
    const height = type === "col" ? canvas.y : 2;

    lines = lines.concat([
      {
        x: coords.x,
        y: coords.y,
        width,
        height,
        type,
        index: i,
      },
    ]);
  }
  return lines;
}
